import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { PageTitle } from '../PageTitle';
import { ContentService, DevicesService, GroupingsService, EntityService } from '../../services';
import { EntityIcon } from '../Entity';
import ReactPanZoom from "@ajainarayanan/react-pan-zoom";
import i18next from "i18next";

class DeviceEditGroupMetadata extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      device: null,
      entity: null,
      deviceId: props.match.params.deviceId,
      amtId: props.match.params.amtId,
      amt: null,
      amtGrouping: null,
      errorMessage: null,
      saved: false
    };
  }

  componentDidMount() {
    DevicesService.get(this.state.deviceId).then((response) => {
      const device = response.device;

      this.setState({ device: device });

      // TODO
      console.log(device.serialNumber);
      EntityService.getBySerialNumber(device.serialNumber)
          .then(({ entity }) => this.setState({entity: entity}))
          .catch((error) => {
              console.error(error);
          });

      let validGroupsForAMT = [];
      device.deviceType.metadataTypes.forEach(metadataType => {
        metadataType.groupAssociableMetadataTypes.forEach(amt => {
          // TODO: why can === not be used?
          if (amt.id == this.state.amtId) {
            validGroupsForAMT = amt.validForGroups;
            this.setState({ amt: amt });
          }
        })
      });

      // find parent grouping of this device that is associated with the incoming AMT id
      let amtGrouping = this.findGroupingForAMT(device.deviceGrouping, validGroupsForAMT);

      if (amtGrouping == null) {
        this.setState({ errorMessage: i18next.t('messages.could-not-find-support') });
      } else {
        GroupingsService.get(amtGrouping.id, true).then((response) => {
          this.setState({ amtGrouping: response.grouping });
        }).catch((error) => {
          this.setState({ errorMessage: i18next.t('messages.could-not-load-grouping') });
          console.log(error);
        });
      }
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-device-updating') });
      console.error(error);
    });
  }

  findGroupingForAMT(grouping, validGroupsForAMT) {
    if ((grouping.deviceGroup && validGroupsForAMT.includes(grouping.deviceGroup.id)) ||
        (grouping.deviceGroupId && validGroupsForAMT.includes(grouping.deviceGroupId))) {
      return grouping;
    } else if(grouping.parent != null) {
      return this.findGroupingForAMT(grouping.parent, validGroupsForAMT);
    } else {
      return null;
    }
  }

  collectGroupIdsFromGroupTree(parentGrouping, groupIds) {
    if (parentGrouping != null) {
      this.collectGroupIdsFromGroupTree(parentGrouping.parent, groupIds);
      groupIds.push(parentGrouping.deviceGroupId);
    }
    return groupIds;
  }

  handleSave(locationX, locationY) {
    const amtMetadata = {
      location_x: locationX,
      location_y: locationY
    };

    DevicesService.updateMetadataForAMT(this.state.deviceId, this.state.amtId, amtMetadata).then((response) => {
      this.setState({ saved: true });
    }).catch((error) => {
      console.error(error);
      this.setState({ errorMessage: i18next.t('messages.device-metadata-save-failure') });
    });
  }

  render() {
    // TODO for now this is hard coded for floor plans but it should take into account the AMT id and use the appropriate component based on that
    const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
    const searchValue = this.props.location.state && this.props.location.state.searchValue ? this.props.location.state.searchValue : null;
    const backLinkWithParams = this.props.location.state && this.props.location.state.backLinkWithParams ? this.props.location.state.backLinkWithParams : null;

    if (this.state.saved) {
      return (
        <Redirect to={{
          pathname: `/config/devices/edit/${this.state.deviceId}`,
          state: {
            from: this.props.location,
            successMessage: i18next.t('messages.device-metadata-save-success'),
            backLinkSearch,
            searchValue,
            backLinkWithParams
          } }}
        />
      );
    } else if (this.state.device && this.state.entity && this.state.amtGrouping) {
      return (
        <DeviceEditGroupMetadataInterface
          handleSave={this.handleSave.bind(this)}
          entity={this.state.entity}
          device={this.state.device}
          amtToken={this.state.amt.token}
          amtGrouping={this.state.amtGrouping}
          backLinkSearch={backLinkSearch}
          searchValue={searchValue}
          backLinkWithParams={backLinkWithParams}
        />
      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }

}

class DeviceEditGroupMetadataInterface extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentLocation: this.findCurrentLocation(this.props.device.deviceMetadata, this.props.amtToken),
      dx: 0,
      dy: 0,
      zoom: 1,
      removed: false, 
      loading: true
    };

    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.onPan = this.onPan.bind(this);
  }

  zoomIn() {
    this.setState({
      zoom: this.state.zoom + 0.2
    });
  }

  zoomOut() {
    if (this.state.zoom > 0.2) {
      this.setState({
        zoom: this.state.zoom - 0.2
      });
    }
  }

  onPan(dx, dy) {
    this.setState({
      dx,
      dy
    });
  }

  renderPanZoomControls() {
    return (
      <div className="op-floor-plan-zoom">
        <div className="row">
          <div className="col-sm-12">
            <button onClick={this.zoomIn} type="button" className="btn btn-default btn-block btn-following-row"><span>+</span></button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <button onClick={this.zoomOut} type="button" className="btn btn-default btn-block btn-following-row"><span style={{fontSize: '18px', fontWeight: '600', lineHeight:'22px'}}>-</span></button>
          </div>
        </div>
      </div>
    )
  }

  handleSave() {
    this.props.handleSave(this.state.currentLocation[0], this.state.currentLocation[1]);
  }

  handleRemove(){
    this.handleClick({pageX: -1,pageY: -1})
  }

  handleClick({pageX, pageY}) {
    const rect = this.refs.mapImage.getBoundingClientRect();
    this.setState({
      currentLocation: [(pageX - rect.left - window.scrollX) * (1.0 / this.state.zoom) - (12 / this.state.zoom), (pageY - rect.top - window.scrollY) * (1.0 / this.state.zoom) - (12 / this.state.zoom)],
      removed: true
    });
  }

  findCurrentLocation(currentMetadata, amtToken) {
    const xyMetadata = currentMetadata.filter(metadata => metadata.deviceMetadataType.groupAssociableMetadataTypes.filter(groupAMT => groupAMT.token === amtToken));
    let xyCords = [-10000, -10000];
    xyMetadata.forEach(xyValue => {
      if (xyValue.deviceMetadataType.name === 'location_x') xyCords[0] = xyValue.numericValue;
      if (xyValue.deviceMetadataType.name === 'location_y') xyCords[1] = xyValue.numericValue;
    });

    if (xyCords[0] === -1000 || xyCords[1] === -1000 || xyCords[0] === null || xyCords[1] == null) {
      return null;
    } else {
      return xyCords;
    }
  }

  extractFloorPlanOverlays(currentDeviceId, amtDevices, amtToken, zoom) {
    return amtDevices.map(device => {
      const xyMetadata = device.deviceMetadata.filter(metadata => metadata.deviceMetadataType.groupAssociableMetadataTypes.filter(groupAMT => groupAMT.token === amtToken));
      let xyCords = [-1, -1];
      let size = (24 / zoom).toString() + 'px';
      xyMetadata.forEach(xyValue => {
        if (xyValue.deviceMetadataType.name === 'location_x') xyCords[0] = xyValue.numericValue;
        if (xyValue.deviceMetadataType.name === 'location_y') xyCords[1] = xyValue.numericValue;
      });
      const popoverHoverFocus = (
          <Tooltip id="popover-trigger-hover-focus">{device.displayName}</Tooltip>
      );

      const iconOpacity = device.id === currentDeviceId ? '1.0' : '0.3';

      if ((xyCords[0] != null && xyCords[0] >= 0) && (xyCords[1] != null && xyCords[1] >= 0)) {
        if (device.id !== currentDeviceId || !this.state.removed)
          return (
              <OverlayTrigger
                  key={device.id}
                  trigger={['hover', 'focus']}
                  placement={xyCords[0] > 300 ? 'left' : 'right'}
                  overlay={popoverHoverFocus}>
                <EntityIcon
                    style={device.id === currentDeviceId ? {opacity: iconOpacity, position: 'absolute', top: xyCords[1], left: xyCords[0], width: size, height: size, visibility: 'visible', boxShadow: '0 4px 14px rgba(0,0,0,.78)', borderRadius: '50%'} : {opacity: iconOpacity, position: 'absolute', top: xyCords[1], left: xyCords[0], width: size, height: size, visibility: 'visible'}}
                    entity={this.props.entity}
                />
              </OverlayTrigger>
          );
        else {
          return null
        }
      }
      else {
        return null
      }
    });
  }

  extractFloorPlanData(amtToken, amtGroupingSupportEntries) {
    return amtGroupingSupportEntries
        .filter(supportEntry => supportEntry.groupAssociableMetadataType.token === amtToken)
        .reduce((map, supportEntry) => {
          map[supportEntry.token] = supportEntry.value;
          return map;
        }, {});
  }

  componentDidMount() {
    const floorPlanAMTData = this.extractFloorPlanData(this.props.amtToken, this.props.amtGrouping.amtGroupingSupportEntries);
    if (floorPlanAMTData && floorPlanAMTData['floor_plan_image']) {      
      ContentService.getDeviceGroupingImage(this.props.amtGrouping.id, floorPlanAMTData['floor_plan_image']).then(response => {
        this.setState({mapURL: response, loading: false});
      });
    } else {
      this.setState({loading: false});
    }
  }

  render() {
    let currentLocationMarker = null;
    if (this.state.currentLocation != null) {
      let size = (24 / this.state.zoom).toString() + 'px';
      currentLocationMarker = (
          <EntityIcon
              style={{opacity: '1.0', position: 'absolute', left: this.state.currentLocation[0], top: this.state.currentLocation[1], width: size, height: size, visibility: 'visible', boxShadow: '0 4px 14px rgba(0,0,0,.78)', borderRadius: '50%'}}
              entity={this.props.entity}
          />
      );
    }

    const backLinkWithParams = {
      link: {
        pathname: `/config/devices/edit/${this.props.device.id}`,
        state: {
          backLinkSearch: this.props.backLinkSearch,
          searchValue: this.props.searchValue,
          backLinkWithParams: this.props.backLinkWithParams
        }
      }
    };

    if (this.state.loading) {
      return (<div className="loader">{ i18next.t('loading') }</div>)
    } else if (!this.state.mapURL || this.state.mapURL === 'images/icon/no_image_icon.svg') {
      return (
        <div>
          <div className="row">
            <PageTitle
              title={`${this.props.amtGrouping.name} ${ i18next.t('pages.edit-group-metadata.floor-map') }`}
              backLinkWithParams={backLinkWithParams}
            />
          </div>
          <div>
            <p className="op-info">
              { i18next.t('messages.no-floor-plan-image', {grouping: this.props.amtGrouping.name}) }<Link to={`/admin/groupings/edit/${this.props.amtGrouping.id}`}>{ i18next.t('messages.no-floor-plan-image-2') }</Link>.
            </p>
          </div>
        </div>
      );
    } else {
        const overlays = this.extractFloorPlanOverlays(this.props.device.id, this.props.amtGrouping.amtDevices[this.props.amtToken], this.props.amtToken, this.state.zoom);
        
        return (
          <div>
            <div className="row">
              <PageTitle
                title={`${this.props.amtGrouping.name} ${ i18next.t('pages.edit-group-metadata.floor-map') }`}
                backLinkWithParams={backLinkWithParams}
              />
            </div>
            <div className="op-content-box">
              <p className="op-info">{ i18next.t('pages.edit-group-metadata.you-are-setting-1') }<strong>{this.props.device.displayName}</strong>. { i18next.t('pages.edit-group-metadata.you-are-setting-2') }</p>
              <div className="container-fluid">
                <div className="col-sm-12">
                  <ScrollArea
                    speed={0.8}
                    className="scroll-container"
                    contentClassName="scrollable-content"
                    horizontal={true}>
                    <ReactPanZoom
                      zoom={this.state.zoom}
                      pandx={this.state.dx}
                      pandy={this.state.dy}
                      onPan={this.onPan}
                    >
                      <div className="store-map-image-wrapper" ref='mapImage' onClick={this.handleClick.bind(this)} style={{position: 'absolute', backgroundImage: `url(${this.state.mapURL})`, width:800, height:600, backgroundSize: '800px 600px', left: '50%', marginLeft: -400, opacity: 0.4}}>
                      </div>
                      <div className="store-map-image-wrapper" ref='mapImage' onClick={this.handleClick.bind(this)} style={{position: 'relative', backgroundImage: `url(${this.state.mapURL})`, width:800, height:600, backgroundSize: '800px 600px', visibility: 'hidden'}}>
                        {currentLocationMarker}
                        {overlays}
                      </div>
                    </ReactPanZoom>
                  </ScrollArea>

                  {this.renderPanZoomControls()}
                </div>
              </div>
              <hr />
              <ul className="list-inline">
                <li>
                  <button type="submit" className="btn btn-primary" onClick={this.handleSave.bind(this)}>{ i18next.t('form-labels.save') }</button>
                </li>
                <li>
                  <button className="btn btn-default" onClick={this.handleRemove.bind(this)}>{ i18next.t('form-labels.remove') }</button>
                </li>
                <li>
                  <Link to={backLinkWithParams.link}>
                    <button className="btn btn-default">{ i18next.t('form-labels.cancel') }</button>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        );
    }
  }
}

export default DeviceEditGroupMetadata;
